export function sleep(delay) {
    return new Promise((resolve) => setTimeout(resolve, delay))
}

function loopObject(start, prop) {
    if(!start) {debugger; return}
    return start[prop];
}

export function output_text(text, $this) {
    if(!text) return;
    text =  text.replace(/{{([^}]*)}}/g, (match, capt) => {
        let arr = capt.split('.');
        //workaround voor tekst.vue, ik snap niet waarom het this wel werkt in chatmessage
        let start = $this || this;
        for(var i = 0; i < arr.length; i++) {
            start = loopObject(start, arr[i])
        }
        if(!start) return
        start = start.toString().replace(".", ",");
        return start;
    })

    //check for images
    text = text.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
        return "<img src='https://pointer-dev.kro-ncrv.nl/cms/" + capture + "' />";
      });
    
    return text;
}